<template>
  <v-app>
    <v-app-bar app color="primary" class="d-print-none">
      <a href="https://dmv.ny.gov/">
        <v-img
          alt="NY DMV Home"
          src="@/assets/dmv-logo.png"
          transition="scale-transition"
          max-width="200"
        />
      </a>
      <v-spacer />

      <v-btn
        v-if="currentComponent != 'Login'"
        class="mb-1 logout"
        @click="navigateTo('Login')"
      >
        <v-icon class="hidden-sm-and-down">mdi-logout</v-icon>
        <span>Logout</span>
      </v-btn>
      <Version />
    </v-app-bar>

    <v-main>
      <div class="primary--text pa-1 grey lighten-2 d-print-none">
        <div class="text-h6 appTitle">Road Test Results</div>
      </div>

      <v-container class="appWidth">
        <component
          :is="currentComponent"
          ref="child"
          v-bind="currentProperties"
          @navigateTo="navigateTo"
        />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Login from '@/pages/Login';
import TestResults from '@/pages/TestResults';
import Receipt from '@/pages/Receipt';
import Version from '@/components/Version.vue';

export default {
  name: 'App',
  components: {
    Login,
    TestResults,
    Receipt,
    Version,
  },
  data: () => ({
    currentComponent: 'Login',
    TestData: null,
    SelectedIndex: 0,
  }),
  computed: {
    currentProperties() {
      if (this.currentComponent === 'TestResults') {
        return { testData: this.TestData };
      } else if (this.currentComponent === 'Receipt') {
        return { testData: this.TestData, selectedIndex: this.SelectedIndex };
      } else {
        return null;
      }
    },
  },
  methods: {
    navigateTo(componentName, TestData, SelectedIndex) {
      this.currentComponent = componentName;
      this.TestData = TestData;
      this.SelectedIndex = SelectedIndex;
    },
  },
};
</script>

<style scoped>
.appTitle {
  margin-left: 15px;
}
.appWidth {
  max-width: 1200px;
}

@media only screen and (max-width: 960px) {
  .logout .v-icon{
    font-size: 18px;
  }

  .logout.v-btn{
    min-width: auto !important;
    height: 25px !important;
  }
}

</style>
